import { render, staticRenderFns } from "./piclist_2.vue?vue&type=template&id=10c982f9&scoped=true"
import script from "./piclist_2.vue?vue&type=script&lang=js"
export * from "./piclist_2.vue?vue&type=script&lang=js"
import style0 from "./piclist_2.vue?vue&type=style&index=0&id=10c982f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c982f9",
  null
  
)

export default component.exports